export const OtherMenu4 = () => {
  return (
    <span>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="base"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g opacity="0.3">
          <path
            d="M3 10C3 8.61929 4.11929 7.5 5.5 7.5C6.88071 7.5 8 8.61929 8 10V18C8 19.3807 6.88071 20.5 5.5 20.5C4.11929 20.5 3 19.3807 3 18V10Z"
            stroke="#1A1A1A"
            strokeWidth="2"
          />
          <path
            d="M11.5754 4.68995L9.34488 8.31457C8.74601 9.28774 8.44657 9.77432 8.26551 10.3075C8.21028 10.4702 8.16347 10.6356 8.12526 10.8031C8 11.3521 8 11.9234 8 13.0661V16.5C8 18.7091 9.79086 20.5 12 20.5H14.9098C16.8037 20.5 18.535 19.43 19.382 17.7361L20.5305 15.439C21.6651 13.1699 20.015 10.5 17.478 10.5H16.7882C15.0593 10.5 13.7371 8.95887 14 7.25L14.243 5.67022C14.3782 4.79201 13.6987 4 12.8101 4C12.3067 4 11.8393 4.26118 11.5754 4.68995Z"
            stroke="#1A1A1A"
            strokeWidth="2"
          />
        </g>
      </svg>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        className="active-icon"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 10C3 8.61929 4.11929 7.5 5.5 7.5C6.88071 7.5 8 8.61929 8 10V18C8 19.3807 6.88071 20.5 5.5 20.5C4.11929 20.5 3 19.3807 3 18V10Z"
          stroke="white"
          strokeWidth="2"
        />
        <path
          d="M11.5754 4.68995L9.34488 8.31457C8.74601 9.28774 8.44657 9.77432 8.26551 10.3075C8.21028 10.4702 8.16347 10.6356 8.12526 10.8031C8 11.3521 8 11.9234 8 13.0661V16.5C8 18.7091 9.79086 20.5 12 20.5H14.9098C16.8037 20.5 18.535 19.43 19.382 17.7361L20.5305 15.439C21.6651 13.1699 20.015 10.5 17.478 10.5H16.7882C15.0593 10.5 13.7371 8.95887 14 7.25L14.243 5.67022C14.3782 4.79201 13.6987 4 12.8101 4C12.3067 4 11.8393 4.26118 11.5754 4.68995Z"
          stroke="white"
          strokeWidth="2"
        />
      </svg>
    </span>
  );
};
